import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faPhone,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const navigate = useNavigate();

  const brand = webinfo?.name || "YourBrand";
  const email = webinfo?.email || "hello@yourdomain.com";
  const phone = webinfo?.phone || "+91 XXXXX XXXXX";
  const address = webinfo?.address || "Your office address";

  return (
    <footer className="footX">
      {/* TOP CTA STRIP */}
      <div className="footX__top">
        <div className="footX__topWrap">
          <div className="footX__topText">
            <span className="footX__kicker">Let’s build your growth system</span>
            <h3>
              Want more leads with a faster website + better follow-up?
            </h3>
            <p>
              Get a quick audit and a clear next-step plan. No fluff — only what
              moves results.
            </p>
          </div>

          <div className="footX__topActions">
            <button className="footX__btn" onClick={() => navigate("/contact")}>
              Request Free Audit <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              className="footX__btn ghost"
              onClick={() => navigate("/services")}
            >
              Explore Services
            </button>
          </div>
        </div>
      </div>

      {/* MAIN FOOTER */}
      <div className="footX__main">
        <div className="footX__wrap">
          {/* Brand */}
          <div className="footX__col footX__brand">
            <h2 className="footX__logo">{brand}</h2>
            <p className="footX__about">
              We help serious brands grow with conversion-first websites,
              performance marketing, and automation. Clear strategy, fast
              execution, measurable results.
            </p>

            <div className="footX__socials" aria-label="Social links">
              {/* add your real links */}
              <a href="#" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="#" aria-label="Twitter/X">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="#" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="#" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>

            <div className="footX__miniTrust">
              <span className="pill">Speed-first builds</span>
              <span className="pill">Tracking included</span>
              <span className="pill">Support you can reach</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footX__col">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/strategies">Our Approach</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footX__col">
            <h4>Services</h4>
            <ul>
              <li><a href="/services/web-dev">Web & Landing Pages</a></li>
              <li><a href="/services/seo">SEO & Content</a></li>
              <li><a href="/services/ads">Performance Ads</a></li>
              <li><a href="/services/automation">Automation & CRM</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footX__col">
            <h4>Contact</h4>

            <div className="footX__info">
              <div className="infoRow">
                <span className="ico"><FontAwesomeIcon icon={faEnvelope} /></span>
                <a href={`mailto:${email}`}>{email}</a>
              </div>

              <div className="infoRow">
                <span className="ico"><FontAwesomeIcon icon={faPhone} /></span>
                <a href={`tel:${phone}`}>{phone}</a>
              </div>

              <div className="infoRow">
                <span className="ico"><FontAwesomeIcon icon={faLocationDot} /></span>
                <span className="addr">{address}</span>
              </div>
            </div>

            <div className="footX__note">
              <b>Reply time:</b> usually within 24 hours.
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footX__bottom">
          <div className="footX__bottomWrap">
            <p>
              © {new Date().getFullYear()} {brand}. All rights reserved.
            </p>

            <div className="footX__legal">
              <a href="/terms-and-condition">Terms</a>
              <span className="sep">•</span>
              <a href="/privacy-policy">Privacy</a>
              <span className="sep">•</span>
              <a href="/disclaimer">Disclaimer</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;